import Link from 'next/link'
import CustomerLogos from '@comp/ui/customer-logos'
import { useRouter } from 'next/router'
import { AccessHero, PlatformFlow, DeveloperFeatures, ExperienceIcon } from './home-experience'
import styles from './home-experience.module.css'


export default function HomeV4() {
  const { locale } = useRouter()
  const lang = locale === 'tr' ? 'tr' : 'en'
  const tr = lang === 'tr'
  return (
    <main className={styles.home}>
      <style jsx global>{`#monofor-demo-button { display: none; }`}</style>
      <AccessHero lang={lang} />
      <CustomerLogos lang={lang} />
      <PlatformFlow lang={lang} />
      <section className={styles.aiBand}>
        <div className={styles.aiCopy}>
          <p className={styles.kicker}>AI {tr ? 'GÜVENLİĞİ' : 'SECURITY'}</p>
          <h2>{tr ? 'Yeni ekip arkadaşınızın da bir kimliğe ihtiyacı var.' : 'Your newest teammate needs an identity, too.'}</h2>
          <p>{tr ? 'Her AI ajanına bir kimlik, bir sahip ve açık erişim sınırları tanımlayın. Yetkilendirmeyi modelin dışında tutun, her işlemi kaydedin.' : 'Give every AI agent an identity, an owner, and clear boundaries. Keep authorization outside the model and every action on the record.'}</p>
          <Link href="/solutions/ai-security">{tr ? 'AI güvenliğini keşfedin' : 'Explore AI security'}<ExperienceIcon name="arrow" size={16} /></Link>
        </div>
        <div className={styles.agentCard} aria-label={tr ? 'Örnek AI ajanı erişim politikası' : 'Example AI agent access policy'}>
          <div className={styles.agentTop}><span className={styles.agentAvatar}><ExperienceIcon name="bot" size={24} /></span><div><strong>deploy-agent</strong><span>{tr ? 'Sahip: Platform ekibi' : 'Owner: Platform team'}</span></div><span className={styles.agentBadge}>{tr ? 'Yönetiliyor' : 'Governed'}</span></div>
          <div className={styles.agentPolicy}><div><span>identity</span><strong>sa-deploy-001</strong></div><div><span>scope</span><strong>deploy:production</strong></div><div><span>token.ttl</span><strong>15 min</strong></div><div><span>audit</span><strong>{tr ? 'etkin' : 'enabled'}</strong></div></div>
          <div className={styles.agentDecision}><span>{tr ? 'Örnek politika' : 'Example policy'}</span><span><ExperienceIcon name="shield" size={14} />{tr ? 'Sınırlar tanımlı' : 'Boundaries enforced'}</span></div>
        </div>
      </section>
      <DeveloperFeatures lang={lang} />
      <section className={styles.stats} aria-label={tr ? 'Monofor rakamlarla' : 'Monofor in numbers'}>
        <div><strong>50M+</strong><span>{tr ? 'Güvence altındaki kimlik' : 'Identities secured'}</span></div>
        <div><strong>{tr ? '7.000+' : '7,000+'}</strong><span>{tr ? 'Kurumsal entegrasyon' : 'Enterprise integrations'}</span></div>
        <div><strong>40+</strong><span>{tr ? 'Ülke' : 'Countries'}</span></div>
      </section>
      <section className={styles.finalCta}>
        <p className={styles.kicker}>{tr ? 'SONRAKİ ADIM' : 'YOUR NEXT MOVE'}</p>
        <h2>{tr ? 'Erişimin kontrolünü elinize alın.' : 'Make every connection a secure one.'}</h2>
        <p>{tr ? 'Dakikalar içinde kendi deneme ortamınızı oluşturun. Kredi kartı gerekmez.' : 'Your own trial environment, ready in minutes. No credit card required.'}</p>
        <div className={styles.actions}><Link href="/try/now" className={styles.primary}>{tr ? 'Ücretsiz deneyin' : 'Start free trial'}<ExperienceIcon name="arrow" size={17} /></Link><Link href="/contact" className={styles.secondary}>{tr ? 'Uzmanla görüşün' : 'Talk to an expert'}<span aria-hidden>↗</span></Link></div>
      </section>
    </main>
  )
}
